
import './index.css';
import Home from './components/home';

function App() {
  return (
    <div className="bg-default font-sans leading-normal tracking-normal">
      <Home />
    </div>
  );
}

export default App;
